import { CodedError } from './CodedError';
import { errorCodes } from './constants/errorCodes';

export default class NotAuthorizedError extends CodedError {
  static get errorName() {
    return errorCodes.notAuthorizedError.code;
  }

  constructor(message: string = errorCodes.notAuthorizedError.message) {
    super(message);
    this.code = errorCodes.notAuthorizedError.code;
    this.message = `${message} ${errorCodes.notAuthorizedError.code}`;
    this.name = errorCodes.notAuthorizedError.name;

    this.status = errorCodes.notAuthorizedError.status;

  }
}
